import runtimeConfig from '../generated/frontend-config.json';

export type AuthRuntimeConfig = typeof runtimeConfig.auth;
export type ResourcesRuntimeConfig = typeof runtimeConfig.resources;
export type FrontendRuntimeConfig = typeof runtimeConfig;

export const frontendRuntimeConfig: FrontendRuntimeConfig = runtimeConfig;
export const authConfig: AuthRuntimeConfig = runtimeConfig.auth;
export const awsResources: ResourcesRuntimeConfig = runtimeConfig.resources;
